import {
    GET_DROPDOWN,
    GET_DROPDOWN_SUCCESS,
    GET_DROPDOWN_FAILURE,
    RESET_EQUITY_DETAILS,
    PHYSICIAN_LOAD_ALL_LOADING,
    CLEAR_SPECFIC_DROPDOWN_LIST,
} from '../actions';

const initialState = {
    districts: {
        items: [],
        loading: false,
        statusCode: '',
        statusMessage: '',
    },
    territories: {
        items: [],
        loading: false,
        statusCode: '',
        statusMessage: '',
    },
    accountLookup: {
        items: [],
        loading: false,
        statusCode: '',
        statusMessage: '',
    },
    accounts: {
        items: [],
        loading: false,
        statusCode: '',
        statusMessage: '',
    },
    procedureList: {
        items: [],
        loading: false,
        statusCode: '',
        statusMessage: '',
    },
    caseCoverageEmployees: {
        items: [],
        loading: false,
        statusCode: '',
        statusMessage: '',
    },
    physicianList: {
        items: [],
        loading: false,
        statusCode: '',
        statusMessage: '',
        loadAll: false,
        physicianLoadAllLoading: false,
    },
    templates: {
        items: [],
        loading: false,
        statusCode: '',
        statusMessage: '',
    },
    billToDetails :{
        items: [],
        loading: false,
        statusCode: '',
        statusMessage: '',
    },
};

const equityDetailsDropdownsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DROPDOWN:
            return {
                ...state,
                [action.payload.dropDownName]: {
                    ...state[action.payload.dropDownName],
                    loading: true,
                },
            };
        case PHYSICIAN_LOAD_ALL_LOADING:
            return {
                ...state,
                physicianList: {
                    ...state.physicianList,
                    physicianLoadAllLoading: true,
                },
            };
        case GET_DROPDOWN_SUCCESS:
            return {
                ...state,
                [action.name]: {
                    ...state[action.name],
                    loading: false,
                    physicianLoadAllLoading: false,
                    items: action.items,
                    loadAll:
                        action.loadAll != undefined
                            ? action.loadAll
                            : state.physicianList.loadAll,
                },
            };
        case GET_DROPDOWN_FAILURE:
            return {
                ...state,
                [action.name]: {
                    ...state[action.name],
                    loading: false,
                    items: [],
                    statusCode: action.statusCode,
                    statusMessage: action.statusMessage,
                },
            };
        case CLEAR_SPECFIC_DROPDOWN_LIST:
            return {
                ...state,
                [action.payload.name]: {
                    ...state[action.payload.name],
                    items: [],
                },
            };
        case RESET_EQUITY_DETAILS:
            return {
                ...state,
                ...initialState,
            };
        default: {
            return { ...state };
        }
    }
};

export default equityDetailsDropdownsReducer;
